



































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import {
    faDollarSign,
    faUser,
    faUserPlus,
    faHomeAlt,
    faBars,
    faSignOut,
    faListAlt,
    faSearch,
    faKey,
    faMedkit,
    faUnlockAlt,
} from '@fortawesome/pro-regular-svg-icons';
import { Resolve } from 'vue-di';
import { ProgramState } from '../types/types';
import { BaseView } from './BaseView';
import { Title } from '~/decorators/Title';
import SessionModule from '~/store/session';
import styles from '~/assets/style/variables.scss';
import EnrollmentModule from '~/store/enrollment';
import Eligibility from '~/store/eligibility';
import EventBus from '~/services/eventBus';
import Path from '~/store/path';

@Component<SideBar>({
    layout: 'default',
    icons: {
        faDollarSign,
        faUser,
        faHomeAlt,
        faBars,
        faListAlt,
        faSignOut,
        faSearch,
        faUserPlus,
        faKey,
        faMedkit,
        faUnlockAlt,
    },
})
export default class SideBar extends BaseView {
    @Resolve
    public session!: SessionModule;
    @Resolve
    enrollment!: EnrollmentModule;
    @Resolve
    eligibility!: Eligibility;
    @Resolve
    eventBus!: EventBus;
    @Resolve
    public path!: Path;

    styles = styles;
    ProgramState = ProgramState;

    private _drawer = true;
    right = false;
    left = true;
    // minWindowSize = 1024;
    minWindowSize = 310;
    isAutosize = true;

    get dashboard() {
        return this.$settings.landingMenu.filter(item => item.isLandingMenu);
    }

    get panel() {
        return this.session.panel;
    }

    set panel(value: any) {
        this.session.setPanel(value);
    }

    get panelIndex() {
        return this.session.panelIndex;
    }

    set panelIndex(value: any) {
        this.session.setPanelIndex(value);
    }

    get medicinePanel() {
        return this.session.medicinePanel;
    }

    set medicinePanel(value: any) {
        this.session.setMedicinePanel(value);
    }

    @Watch('panelIndex')
    watchPanelIndex() {
        if (this.session.isMiniVariant && this.session.panelIndex >= 0) {
            this.session.toggleMiniVariant();
            if (this.session.isMiniVariant) {
                this.medicinePanel = null;
            }
        }
    }

    handleMiniClick() {
        this.isAutosize = false;
        this.session.toggleMiniVariant();
        if (this.session.isMiniVariant) {
            this.medicinePanel = null;
        }
    }

    handleResize() {
        if (window.outerWidth < this.minWindowSize && !this.session.isMiniVariant && this.isAutosize) {
            this.session.toggleMiniVariant();
            if (this.session.isMiniVariant) {
                this.medicinePanel = null;
            }
        } else if (window.outerWidth >= this.minWindowSize && this.session.isMiniVariant && this.isAutosize) {
            this.session.toggleMiniVariant();
            if (this.session.isMiniVariant) {
                this.medicinePanel = null;
            }
        }
    }

    get isMiniVariant() {
        return this.session.isMiniVariant;
    }

    get drawer() {
        return this._drawer;
    }

    set drawer(value: boolean) {
        this._drawer = value;
    }

    get icons() {
        // return this.$vuetify.icons.values.radioOn;
        return null;
    }

    get menuItems() {
        return [
            {
                icon: 'fal fa-home',
                text: 'Home',
            },
        ];
    }

    handleMedicineExpand() {
        if (this.isMiniVariant) {
            this.isAutosize = false;
            this.session.toggleMiniVariant();
        }
    }

    sendTo(page: string, programState = ProgramState.Gilead) {
        const forceRefresh = this.$route.path === page;
        this.enrollment.setProgramState(programState);
        this.eventBus.nextProgramChange();
        // this.eligibility.clear();
        this.enrollment.clearAll();

        const normalizedPage = page.toLowerCase().replace(/\/+$/, '');
        if (normalizedPage === '/enrollment/eligibility') {
            this.path.setPath('enroll-new-patient');
        } else if (normalizedPage === '/patient/patientsearch') {
            this.path.setPath('patient-search');
        }

        if (forceRefresh) {
            this.$router.go(0);
        } else {
            this.$router.push({ path: page });
        }
    }

    async handleLogOut() {
        await this.session.logout({ returnTo: this.$settings.absoluteUrlFromRoute({ name: 'index' }).replace('/madrigal/rezdiffra', '') });
    }

    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    }
}
